@use "../../styles/breakpoint" as *;

.wrapper {
    align-items: center;
    background: linear-gradient(0deg, #0a2240 -10%, #326295 130%);
    background-color: var(--shuttle);
    color: var(--white);
    display: flex;
    height: 100px;
    justify-content: center;
    position: relative;
    text-align: center;
    z-index: 100;

    @media ($below-mobile) {
        flex-flow: column nowrap;
        align-items: center;
        padding: 0 2rem 7px;
        height: 160px;
    }

    & > div {
        display: flex;
        flex-direction: column;
        justify-content: center;

        @media ($below-mobile) {
            padding-top: 1.5rem;
        }
    }
}

.img {
    height: 131px;
    margin-right: 2rem;
    position: relative;
    top: -17%;

    @media ($below-mobile) {
        position: absolute;
        top: -80px;
        left: 0;
        right: 0;
        margin-left: auto;
        margin-right: auto;
    }
}

.title {
    font-size: 1.125rem;
    font-weight: bold;

    @media ($below-mobile) {
        margin-bottom: 1rem;
    }
}

.copy {
    font-size: 0.875rem;
}
